import Image from 'next/image'
export default function CertIcons({ _classes, product}) {

  return (
  <div className={_classes ? _classes : "lexcms-product-certs-container"}>
          {product?.certifications?.map((cert, i) => { 
            return (<div key={i} className="lexcms-product-cert-image-container">
              <Image
                priority
                src={cert.url}
                height={65}
                width={65}
                alt={""}
                className="lexcms-product-cert-image"
              />
            </div>
            )
          })
          }
        </div>
  )

}
